<template>
  <div class="floating-window">
    <div>{{ $t("home.welcome") }}</div>
    <div>{{ $t("home.credit") }}: {{ creditAmount }}$</div>
  </div>
</template>

<script>
export default {
  name: 'CreditFloatingWnd',
  props: {
    creditAmount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.floating-window {
  position: fixed;
  top: 10px;
  right: 20px;
  background-color: rgba(1, 15, 77, 0.8);
  color: white;
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .floating-window {
    top: auto;
    bottom: 5px;
    right: 5px;
    padding: 5px;
    font-size: 14px;
  }
}
</style>
